








































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { CSSStyleOptions } from '@sonicwall/unified-ui-framework/src/shared/common-types';
import { SwScrollView } from './';

@Component({
  components: {
    SwScrollView,
  },
})
export default class SwDropdown extends SwExtendedVue {
  @Prop({ type: Boolean, default: true })
  withArrow: boolean;

  @Prop({ type: Number, default: 500 })
  maxWidth: number;

  @Prop({ type: Number, default: 250 })
  maxHeight: number;

  @Prop({ type: [Number] })
  width: number | undefined;

  @Prop({ type: Array, default: [] })
  customClasses: string[];

  cssPrefix: string = 'dropdown_main';

  get innerStyle(): CSSStyleOptions {
    // console.log('Styx:: ', (document.getElementsByClassName('sw-scroll-view__view__cont')[0] as HTMLElement));
    return {
      maxHeight: this.maxHeight ? `${this.maxHeight}px` : undefined,
      maxWidth: this.maxWidth ? `${this.maxWidth}px` : undefined,
      width: this.width !== undefined ? `${this.width}px` : undefined,
      marginBottom: '-11px',
    };
  }
}
